/*
  Know Your Size calculator for the master BMSM sections.

  The dropdown choices and the band+cup -> BOOMBA size answer are DERIVED from
  window.BMSM_SIZE_EQUIV (snippets/master-bmsm-size-equivalents.liquid) - the same
  map that prints the "M fits bra sizes: ..." line under the swatches. Inverting one
  map instead of shipping a second one is deliberate: the PDP calculator keeps ~20
  parallel handleArray / cupSizes / bandSizes lists in layout/theme.liquid and those
  have drifted from the published sizing guides more than once.

  Because the map is filtered by the product's real size option values, the same code
  answers "M" for the Comfy Bra (XS..3XL) and "E" for the Plunge (AA..R) with no
  per-product configuration.
*/
(function () {
  'use strict';

  if (window.__bmsmFindSizeReady) {
    return;
  }
  window.__bmsmFindSizeReady = true;

  /* Display order for the cup dropdown. Anything unrecognised sorts to the end. */
  var CUP_ORDER = [
    'AA', 'A', 'B', 'C', 'D', 'DD/E', 'DDD/F',
    'G', 'H', 'I', 'J', 'K', 'L', 'M',
    'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U'
  ];

  function splitBraSize(token) {
    var match = /^(\d+)\s*(\S.*)$/.exec(token.trim());

    if (!match) {
      return null;
    }

    return { band: match[1], cup: match[2].trim() };
  }

  function byCupOrder(a, b) {
    var indexA = CUP_ORDER.indexOf(a);
    var indexB = CUP_ORDER.indexOf(b);

    if (indexA === -1) {
      indexA = CUP_ORDER.length;
    }
    if (indexB === -1) {
      indexB = CUP_ORDER.length;
    }

    return indexA - indexB || a.localeCompare(b);
  }

  /*
    Cup sizes and garment sizes collide on "L" and "M", so settle which scale this
    product sells before inverting anything. A value only the garment map knows (XS,
    XL, 2XL, 3XL) proves it; everything else is a cup-lettered product.
  */
  function pickScale(sizeValues) {
    var cups = window.BMSM_SIZE_EQUIV_CUP || {};
    var garments = window.BMSM_SIZE_EQUIV_GARMENT || {};

    var isGarmentScale = sizeValues.some(function (size) {
      return Object.prototype.hasOwnProperty.call(garments, size)
        && !Object.prototype.hasOwnProperty.call(cups, size);
    });

    if (isGarmentScale) {
      return garments;
    }

    return Object.keys(cups).length ? cups : (window.BMSM_SIZE_EQUIV || {});
  }

  /*
    Invert the equivalence map into { "34DD/E": "M" }, keeping only the sizes this
    product actually sells so a Comfy Bra never answers with a cup letter.
  */
  function buildIndex(sizeValues) {
    var equivalents = pickScale(sizeValues);
    var answers = {};
    var bands = {};
    var cups = {};

    sizeValues.forEach(function (size) {
      var list = equivalents[size];

      if (!list) {
        return;
      }

      list.split(',').forEach(function (token) {
        var parsed = splitBraSize(token);

        if (!parsed) {
          return;
        }

        var key = parsed.band + parsed.cup;

        if (!Object.prototype.hasOwnProperty.call(answers, key)) {
          answers[key] = size;
        }

        bands[parsed.band] = true;
        cups[parsed.cup] = true;
      });
    });

    return {
      answers: answers,
      bands: Object.keys(bands).sort(function (a, b) { return Number(a) - Number(b); }),
      cups: Object.keys(cups).sort(byCupOrder)
    };
  }

  function fillSelect(select, values) {
    values.forEach(function (value) {
      var option = document.createElement('option');

      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  }

  /*
    Grey out the cup letters that have no variant at the chosen band, the same
    courtesy the PDP calculator does with its disableMap tables.
  */
  function syncCupAvailability(index, bandSelect, cupSelect) {
    var band = bandSelect.value;

    Array.prototype.forEach.call(cupSelect.options, function (option) {
      if (!option.value) {
        return;
      }

      option.disabled = band !== ''
        && !Object.prototype.hasOwnProperty.call(index.answers, band + option.value);
    });

    var selected = cupSelect.options[cupSelect.selectedIndex];

    if (selected && selected.disabled) {
      cupSelect.value = '';
    }
  }

  function findIn(scope, selector, matches) {
    var found = null;

    Array.prototype.forEach.call(scope.querySelectorAll(selector), function (el) {
      if (!found && matches(el)) {
        found = el;
      }
    });

    return found;
  }

  /*
    Move the size picker onto the answer so price, thumbnail and fit line follow.

    The section renders the size control in two shapes and they share nothing:
      picker_type "block"     radios, name="<Option Name>", value="<size>"
      picker_type "dropdown"  <button role="option" value="<size>"> inside an
                              <hdt-richlist>, with the value the form reads living in a
                              hidden input named by POSITION - option1 / option2 / ...
    Only the first shape existed here, so on a dropdown instance the calculator answered
    and the picker never moved, silently. Clicking beats writing values because the
    theme's own handlers (button label, popover close, variant resolve) then run.

    Scoped to the size <fieldset>, not the whole section: in dropdown mode the colour
    picker emits role="option" buttons too.
  */
  function selectSize(root, optionName, optionIndex, size) {
    var scope = root.closest('fieldset')
      || root.closest('.hdt-master-buy-more-save-more-section')
      || document;

    var radio = findIn(scope, 'input[is-value][type="radio"]', function (input) {
      return input.name === optionName && input.value === size;
    });

    if (radio) {
      if (radio.classList.contains('is-unavailable')) {
        return false;
      }
      if (radio.checked) {
        return true;
      }

      radio.click();

      /* Belt and braces if something swallowed the click. */
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      return true;
    }

    var choice = findIn(scope, '[role="option"]', function (button) {
      return button.getAttribute('value') === size;
    });

    if (!choice || choice.classList.contains('is-unavailable')) {
      return false;
    }

    choice.click();

    /*
      hdt-richlist can ignore a synthetic click while its popover is closed, so mirror
      what the section's own combined-dropdown handler does: write the hidden option
      input and let the variant picker re-render off it.
    */
    var hidden = scope.querySelector('input[is-value][name="option' + optionIndex + '"]');

    if (hidden && hidden.value !== size) {
      hidden.value = size;

      var picker = scope.closest('hdt-variant-picker')
        || document.querySelector('hdt-variant-picker');

      if (picker) {
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    return true;
  }

  /*
    Expand / collapse timings are lifted from the theme's own <hdt-accordion>
    (global.min.js), which is what animates the PDP "Find your size" widget: 250ms
    ease on height, body crossfading over 150ms with a 4px lift, offset so it lands
    as the height settles. Reproduced here rather than adopting <details> +
    .omr-accordion-item, whose pink 16px-radius chrome would fight the white card
    this panel is meant to be.
  */
  var HEIGHT_MS = 250;
  var FADE_MS = 150;

  function prefersReducedMotion() {
    return !!window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function verticalBorder(root) {
    var cs = window.getComputedStyle(root);

    return (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
  }

  /* Variant A has no header of its own - its opener lives in the size row. */
  function collapsedHeight(root) {
    var toggle = root.querySelector('[data-bmsm-find-size-toggle]');

    /* Border-box, so the card's own hairline is part of the collapsed height. */
    return toggle ? toggle.offsetHeight + verticalBorder(root) : 0;
  }

  function setPanelOpen(root, isOpen, animate) {
    var panel = root.querySelector('[data-bmsm-find-size-panel]');
    var toggle = root.querySelector('[data-bmsm-find-size-toggle]');

    if (toggle) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (!panel) {
      return;
    }

    /* A faster second click supersedes whatever is still running. */
    if (root.bmsmAnimation) {
      root.bmsmAnimation.cancel();
      root.bmsmAnimation = null;
    }

    if (!animate || !root.animate || prefersReducedMotion()) {
      panel.hidden = !isOpen;
      return;
    }

    var from = isOpen ? collapsedHeight(root) : root.offsetHeight;

    panel.hidden = false;

    /*
      offsetHeight, not scrollHeight (which is what hdt-accordion reads): the panel is
      already un-hidden here, so this is the settled border-box height. scrollHeight
      leaves the card's 1px hairlines out and the last frame lands 2px short.
    */
    var to = isOpen ? root.offsetHeight : collapsedHeight(root);

    root.style.overflow = 'hidden';
    root.bmsmAnimation = root.animate(
      { height: [from + 'px', to + 'px'] },
      { duration: HEIGHT_MS, easing: 'ease' }
    );

    panel.animate(
      isOpen
        ? { opacity: [0, 1], transform: ['translateY(4px)', 'translateY(0)'] }
        : { opacity: [1, 0] },
      {
        duration: FADE_MS,
        delay: isOpen ? HEIGHT_MS - 100 : 0,
        easing: 'ease',
        fill: 'backwards'
      }
    );

    root.bmsmAnimation.finished.then(function () {
      root.style.overflow = '';
      root.bmsmAnimation = null;

      if (!isOpen) {
        panel.hidden = true;
      }
    }).catch(function () {
      /* cancelled mid-flight by the next click - that call owns the cleanup */
    });
  }

  function initWidget(root) {
    if (root.dataset.bmsmFindSizeInit === 'true') {
      return;
    }
    root.dataset.bmsmFindSizeInit = 'true';

    var optionName = root.dataset.optionName || 'Size';
    var optionIndex = root.dataset.optionIndex || '1';
    var sizeValues = (root.dataset.sizeValues || '').split('|').filter(Boolean);
    var index = buildIndex(sizeValues);

    var bandSelect = root.querySelector('[data-bmsm-find-size-band]');
    var cupSelect = root.querySelector('[data-bmsm-find-size-cup]');
    var submit = root.querySelector('[data-bmsm-find-size-submit]');
    var result = root.querySelector('[data-bmsm-find-size-result]');
    var resultText = root.querySelector('[data-bmsm-find-size-result-text]');
    var resultValue = root.querySelector('[data-bmsm-find-size-result-value]');

    /*
      No equivalences for this product means the calculator cannot answer anything.
      Hiding it beats showing two empty dropdowns.
    */
    if (!index.bands.length || !index.cups.length) {
      root.hidden = true;
      return;
    }

    fillSelect(bandSelect, index.bands);
    fillSelect(cupSelect, index.cups);

    bandSelect.addEventListener('change', function () {
      syncCupAvailability(index, bandSelect, cupSelect);
    });

    submit.addEventListener('click', function () {
      var band = bandSelect.value;
      var cup = cupSelect.value;

      result.hidden = false;

      /* Clear the previous answer too - CSS hides the pill, screen readers do not. */
      if (!band || !cup) {
        result.classList.add('bmsm-find-size__result--error');
        resultText.textContent = root.dataset.msgIncomplete;
        resultValue.textContent = '';
        return;
      }

      var size = index.answers[band + cup];

      if (!size) {
        result.classList.add('bmsm-find-size__result--error');
        resultText.textContent = root.dataset.msgNoMatch;
        resultValue.textContent = '';
        return;
      }

      result.classList.remove('bmsm-find-size__result--error');
      resultText.textContent = root.dataset.resultLabel;
      resultValue.textContent = size;
      selectSize(root, optionName, optionIndex, size);
    });

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-bmsm-find-size-toggle]'),
      function (toggle) {
        toggle.addEventListener('click', function () {
          setPanelOpen(root, toggle.getAttribute('aria-expanded') !== 'true', true);
        });
      }
    );

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-bmsm-find-size-close]'),
      function (close) {
        close.addEventListener('click', function () {
          setPanelOpen(root, false, true);
        });
      }
    );
  }

  /* Variant A's opener lives in the size row, outside the widget it controls. */
  function initOpeners() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-bmsm-find-size-open]'),
      function (link) {
        if (link.dataset.bmsmFindSizeInit === 'true') {
          return;
        }
        link.dataset.bmsmFindSizeInit = 'true';

        link.addEventListener('click', function () {
          var root = document.getElementById(link.dataset.bmsmFindSizeOpen);

          if (!root) {
            return;
          }

          var panel = root.querySelector('[data-bmsm-find-size-panel]');

          setPanelOpen(root, panel ? panel.hidden : true, true);
        });
      }
    );
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-bmsm-find-size]'),
      initWidget
    );
    initOpeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The theme editor re-renders sections on save; pick up anything new. */
  document.addEventListener('shopify:section:load', init);
})();
